import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppSettings } from "../config/app-settings.js";
import { useSelector, useDispatch } from "react-redux";
import LoginBanner from "../assets/login-bg-11.jpg";
import Logo from "../assets/Broward-Partnerships-for-kids-logo.png";
import {
  PasswordInput,
  TextInput,
} from "../components/common/ui/Inputs/index.js";
import Button from "../components/common/ui/Button.jsx";
import changePasswordSchema from "../validation/changePasswordSchema.js";
import { authActions } from "../_store/auth.slice.js";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication.js";
import { encryptData } from "../utils/encryptDecrypt.js";
import { profileAction } from "../_store/myProfile.slice.js";

function ChangePassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //  const { emailSaveResponse } = useSelector((state) => state.auth);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const changePasswordResponse = useSelector(
    (state) => state.auth.changePasswordResponse
  );
  const [token, setToken] = useState("");
  const [password, setPassword] = useState({
    oldPassword: "",
    password: "",
  });

  useEffect(() => {
    const url = window.location.href;
    const extractedToken = url.split("/").pop();
    setToken(extractedToken);
  }, []);

  // Reponse for reset password
  // useEffect(() => {
  //   if (resetPasswordResponse?.status !== undefined) {
  //     switch (resetPasswordResponse?.status) {
  //       case 1:
  //         showToastNotification("Password reset successfully", "success");
  //         setSubmit(false);
  //         handleReset();
  //         dispatch(authActions.clearForgotPasswordResponse());
  //         break;
  //       case 0:
  //         showToastNotification(resetPasswordResponse?.message, "warning");
  //         setSubmit(false);
  //         break;
  //       default:
  //         showToastNotification("Something went wrong", "warning");
  //         setSubmit(false);
  //         break;
  //     }
  //   }
  // }, [resetPasswordResponse, dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setPassword((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const restrictCharacters = (e, restrictedChars = ["'", "`"]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };

  const togglePasswordVisibility = (type) => {
    type === "password"
      ? setShowPassword((prev) => !prev)
      : setShowConfirmPassword((prev) => !prev);
  };

  // Forgot Password - submit function
  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = changePasswordSchema(password);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    let _oldPassword = encryptData(password?.oldPassword);
    let _password = encryptData(password?.password);

    dispatch(
      authActions.changePassword({
        oldPassword: _oldPassword,
        password: _password,
      })
    )
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          setSubmit(false);
          dispatch(profileAction?.clearProfileResponse());
          dispatch(authActions?.logout())
            .then((result) => {
              if (result?.payload?.status === 1) {
                navigate("/login");
              }
            })
            .catch((err) => { });
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to change password", "error");
        setSubmit(false);
      });

    setSubmit(false);
    handleReset();
  };

  // Handle reset action
  const handleReset = () => {
    setErrorMessage({});
    setPassword({
      oldPassword: "",
      password: "",
    });
  };

  return (
    <>
      <section className="reset-password-section">
        <div className="container">
          <div className="row g-0 login-container">
            <div className="col-md-6 right-panel d-flex align-items-center">
              <span className="sr-only" role="img" alt="BPK Login Page" aria-label="BPK Login Page"></span>
              <div className="right-panel-content w-100">
                <h6 className="mb-2">WELCOME TO</h6>
                <h2 className="fw-bold mb-3 text-nowrap">
                  BROWARD PARTNERSHIPS FOR KIDS
                </h2>
                <p className="px-3 text-white">
                  Together, we open doors of opportunity, care, and support for Broward’s children and families.
                </p>
              </div>
            </div>
            <div className="col-md-6 sign-in">
              <div className="login-form">
                <h2 className="mb-4 text-left">Change Password</h2>

                <form onSubmit={handleSubmit}>
                  <p className="font-size-16">
                    Change your password.
                  </p>
                  <div className="mb-4">
                    <label htmlFor="oldPassword" className="form-label">
                      Old Password<span className="text-danger">*</span>
                    </label>

                    <PasswordInput
                      name="oldPassword"
                      id="oldPassword"
                      ariaLabel="Old Password"
                      onKeyDown={(e) => restrictCharacters(e)}
                      value={password?.oldPassword}
                      handleChange={handleInputChange}
                      placeholder="Old Password"
                      required={true}
                      errorMessage={errorMessage}
                      showPassword={showPassword}
                      togglePasswordVisibility={() =>
                        togglePasswordVisibility("password")
                      }
                      autoComplete="new-password"
                      maxlength={25}
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">
                      New Password<span className="text-danger">*</span>
                    </label>

                    <PasswordInput
                      name="password"
                      ariaLabel="New Password"
                      id="password"
                      onKeyDown={(e) => restrictCharacters(e)}
                      value={password?.password}
                      handleChange={handleInputChange}
                      placeholder="New Password"
                      required={true}
                      errorMessage={errorMessage}
                      showPassword={showConfirmPassword}
                      togglePasswordVisibility={() =>
                        togglePasswordVisibility("confirm")
                      }
                      autoComplete="new-password"
                      maxlength={25}
                    />
                  </div>

                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <Button
                      status="green"
                      type="submit"
                      label="Submit"
                      disabled={submit}
                    />
                    <Button
                      status="reset"
                      label="Reset"
                      type="reset"
                      onClick={handleReset}
                    // disabled={true}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChangePassword;
